(() => {
  // Fixes from the 21 Oct cart tests:
  // - a sold-out tank option disables the kit button instead of failing on add;
  // - a pick needing more than is in stock swaps to the next tier instead of going in short;
  // - live or chilled items get a note, as they ship separately on Perishable Delivery;
  // - the tank is tagged as part of the kit, so the cart groups only that tank with it.
  const NOTE_SOLD_OUT = 'This option is sold out. Choose another option above to add the kit.';
  const NOTE_CHILLED = 'Includes live or chilled items, sent separately by Perishable Delivery (£6.95 at checkout).';

  const install = () => {
    const Kit = customElements.get('aquarium-builder-kit');
    if (!Kit || Kit.prototype.abkFixes) return;
    const proto = Kit.prototype;
    proto.abkFixes = true;

    const available = proto.available;
    proto.available = function (pick) {
      return available.call(this, pick) && pick.items.every(item => !item.limited || item.stock >= item.qty);
    };

    proto.tankSoldOut = function () {
      const tank = this.mainVariant();
      return !!tank && tank.available === false;
    };

    proto.hasChilled = function () {
      return this.kit.slots.some(slot => {
        if (this.removed.has(slot.slot)) return false;
        const r = this.resolve(slot, this.tier);
        return !r.unavailable && r.pick.items.some(item => item.chilled);
      });
    };

    proto.applyFixes = function () {
      if (!this.kit) return;
      const soldOut = this.tankSoldOut();
      const chilled = this.hasChilled();
      this.querySelectorAll('[data-add]').forEach(button => {
        if (!button.dataset.label) button.dataset.label = button.textContent;
        button.disabled = soldOut;
        button.textContent = soldOut ? 'Sold out' : button.dataset.label;
      });
      this.querySelectorAll('[data-status]').forEach(status => {
        let note = status.previousElementSibling;
        if (!note || !note.hasAttribute('data-abk-note')) {
          note = document.createElement('p');
          note.setAttribute('data-abk-note', '');
          note.className = 'abk-status abk-note';
          status.before(note);
        }
        const lines = [soldOut && NOTE_SOLD_OUT, chilled && NOTE_CHILLED].filter(Boolean);
        note.textContent = lines.join(' ');
        note.hidden = !lines.length;
      });
    };

    ['renderSummary', 'renderMobile', 'renderStepper'].forEach(name => {
      const original = proto[name];
      if (typeof original !== 'function') return;
      proto[name] = function (...args) {
        const out = original.apply(this, args);
        this.applyFixes();
        return out;
      };
    });

    proto.addToBasket = async function () {
      const status = this.querySelector('[data-status]');
      const button = this.querySelector('[data-add]');
      const tank = this.mainVariant();
      if (!tank) { status.textContent = 'Choose a colour and cabinet first.'; return; }
      if (this.tankSoldOut()) { this.applyFixes(); return; }
      const kit = {_builder_kit: this.label(this.tier)};
      const items = [{id: Number(tank.id), quantity: 1, properties: kit}];
      for (const slot of this.kit.slots) {
        if (this.removed.has(slot.slot)) continue;
        const r = this.resolve(slot, this.tier);
        if (r.unavailable) continue;
        for (const item of r.pick.items) items.push({id: Number(item.variant), quantity: item.qty, properties: kit});
      }
      button.disabled = true;
      status.textContent = 'Adding to basket…';
      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          // Shopify may add part of the kit and still return an error; send the shopper to the basket to see what went in.
          if (/added to your cart/i.test(error.description || '')) { window.location.assign('/cart'); return; }
          throw new Error(error.description || 'Could not add the kit.');
        }
        window.location.assign('/cart');
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      }
    };

    document.querySelectorAll('aquarium-builder-kit').forEach(el => { if (el.kit) el.render(); });
  };

  if (customElements.get('aquarium-builder-kit')) install();
  else customElements.whenDefined('aquarium-builder-kit').then(install);
})();
